<template lang="pug">
.payment-step
  validation-provider(:rules="{ required: { allowFalse: false } }")
    input.hidden(type="checkbox" :value="!!payment.id")

  //- h4.panel-heading Übersicht
  .panel.mb-8
    .box
      a.preview(href="#" @click="edit('account')")
        .icon
          svg.default-icon(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            )
          edit-icon
        .data
          .field-preview
            .label Name
            .field-value {{ firstName }} {{ lastName }}
          .field-preview(v-if="email")
            .label E-Mail Adresse
            .field-value {{ email }}
          .field-preview(v-if="mobile")
            .label Mobilnummer
            .field-value {{ mobile }}
      template(v-if="billingAddress")
        hr.my-4
        Address(
          :data="billingAddress"
          :show-label="true"
          :show-name="false"
          label="Rechnungsadresse"
          @click="edit('account')"
        )
          template(v-slot:icon)
            .icon
              svg.default-icon(
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              )
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.3"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                )
                //- path(
                //-   stroke-linecap="round"
                //-   stroke-linejoin="round"
                //-   stroke-width="1.3"
                //-   d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                //- )
                //- path(
                //-   stroke-linecap="round"
                //-   stroke-linejoin="round"
                //-   stroke-width="1.3"
                //-   d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                //- )
              edit-icon

  .panel.mb-8
    .box
      ShippingMethod(
        :data="shippingMethod"
        :show-divider="false"
        :show-label="true"
        @click="edit('shipping')"
      )
        template(v-slot:icon)
          .icon
            svg.default-icon(
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            )
              //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
              //- d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              path(
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.3"
                d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
              )
            edit-icon
      template(v-if="shippingAddress")
        hr.my-4
        Address(
          :data="shippingAddress"
          :show-label="true"
          :show-name="false"
          label="Lieferadresse"
          @click="edit('shipping')"
        )
          template(v-slot:icon)
            .icon
              svg.default-icon(
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              )
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.3"
                  d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                )
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.3"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                )
              edit-icon

  .panel.mb-8
    .box
      .preview
        .icon
          svg(
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          )
            //- Dollar
            //- d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"

            //- Euro
            //- d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"

            path(
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.3"
              d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            )
        .data
          .field-preview
            .label Gesamtsumme
            .field-value
              h3.text-2xl {{ grandTotal | moneyFormat(currency) }}
      template(v-if="checkboxes.length")
        hr.my-4
        Checkbox(
          v-for="(checkbox, i) in checkboxes"
          :key="checkbox.id"
          :data="checkbox"
          :show-divider="i + 1 < checkboxes.length"
          @validate="$emit('validate')"
        )
      template(v-if="methods.length === 1")
        hr.my-4
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === payment.id"
          :show-divider="i + 1 < methods.length"
          :show-label="true"
          :valid="valid"
          @select="select"
          @validate="$emit('validate')"
          @error="$emit('error')"
        )

  .no-payment-methods.mb-4(v-if="!methods.length")
    .alert.error
      p Momentan stehen keine Zahlungsmethoden zur Verfügung.

  .payment-methods(v-if="methods.length > 1")
    h4.panel-heading Zahlungsmethode
    .panel.mb-8
      .box
        PaymentMethod(
          v-for="(method, i) in methods" :key="method.id"
          :data="method"
          :active="method.id === payment.id"
          :show-divider="i + 1 < methods.length"
          :valid="valid"
          @select="select"
          @validate="$emit('validate')"
          @error="$emit('error')"
        )
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { get } from '@/helpers';

import { ValidationProvider } from 'vee-validate';

import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';
import Address from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Address';
import PaymentMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/PaymentMethod';
import ShippingMethod from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/ShippingMethod';
import Checkbox from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/Checkbox';

export default {
  name: 'PaymentStep',
  props: {
    sections: {
      type: Array,
      required: false
    },
    valid: {
      type: Boolean,
      default: true
    }
    // form: {
    //   type: Object,
    //   required: true
    // }
  },
  components: {
    EditIcon,
    ValidationProvider,
    PaymentMethod,
    ShippingMethod,
    Checkbox,
    Address
  },
  computed: {
    salutation() {
      let salutation = '';
      if (this.member.gender === 'M') salutation = 'Herr';
      else if (this.member.gender === 'F') salutation = 'Frau';
      return salutation;
    },
    firstName() {
      return this.checkout.form.account.first_name;
    },
    lastName() {
      return this.checkout.form.account.last_name;
    },
    email() {
      return this.checkout.form.account.email;
    },
    phone() {
      return this.checkout.form.account.phone;
    },
    mobile() {
      return this.checkout.form.account.mobile;
    },
    company() {
      return this.checkout.form.account.company;
    },
    billingAddress() {
      return this.checkout.form.account.billing_address;
    },
    shippingAddress() {
      return this.checkout.form.account.shipping_address;
    },
    shippingMethod() {
      return this.checkout.form.shipping;
    },

    currency() {
      return (
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR'
      );
    },
    checkboxes() {
      const sections = this.sections || [];
      return sections.filter(el => el.key === 'checkbox');
    },
    methods() {
      return get(this.cms, 'shop.paymentMethods') || [];
    },

    payment: {
      get() {
        return this.checkout.form.payment;
      },
      set(value) {
        this.setPayment(value);
      }
    },
    ...mapGetters({
      cms: 'CMS',
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      shippingFee: 'shop/shippingFee',
      checkout: 'shop/checkout',
      taxTotal: 'shop/taxTotal',
      grandTotal: 'shop/grandTotal',
      cart: 'shop/cart'
    })
  },
  methods: {
    select(method) {
      this.payment = method;
    },
    edit(key) {
      const steps = this.checkout.steps;
      const step = steps.find(el => el.key === key);
      if (step) this.$emit('navigate-to', step);
    },
    ...mapMutations({
      setPayment: 'shop/setCheckoutFormPayment'
    }),
    ...mapActions({
      validateCheckout: 'shop/validateCheckoutForm'
    })
  },
  mounted() {
    // !this.payment.id && this.methods.length === 1
    if (!this.payment.id && this.methods.length >= 1) {
      this.payment = this.methods[0];
      this.validateCheckout();
    }
  }
};
</script>

<style lang="sass" scoped>
.no-payment-methods
  width: 100%
  @screen md
    @apply mx-auto
    width: 580px

.payment-step
  width: 100%
  @screen md
    width: auto
</style>
